import { ASSETS } from "./assets";

// Services: bilingual name + description, mapped to a custom icon key
export const SERVICES = [
  {
    id: "sandblasting", icon: "sandblasting", scene: ASSETS.heroDesktop,
    it: { name: "Sabbiatura", desc: "Preparazione superfici e rimozione ruggine con sistemi di blasting ad alta efficienza." },
    en: { name: "Sandblasting", desc: "Surface preparation and rust removal with high-efficiency blasting systems." },
  },
  {
    id: "shotblasting", icon: "shotblasting", scene: ASSETS.tankInterior,
    it: { name: "Pallinatura", desc: "Pallinatrici a turbina per un profilo di ancoraggio uniforme e ripetibile." },
    en: { name: "Shot Blasting", desc: "Turbine shot blasting for a uniform, repeatable anchor profile." },
  },
  {
    id: "painting", icon: "painting", scene: ASSETS.protectivePainting,
    it: { name: "Verniciatura protettiva", desc: "Cicli anticorrosivi airless per acciaio, strutture e carpenteria pesante." },
    en: { name: "Protective Painting", desc: "Airless anti-corrosion cycles for steel, structures and heavy carpentry." },
  },
  {
    id: "polyurea", icon: "polyurea", scene: ASSETS.polyureaRoof,
    it: { name: "Poliurea & impermeabilizzazione", desc: "Membrane poliurea a spruzzo, continue e resistenti, senza giunzioni." },
    en: { name: "Polyurea & waterproofing", desc: "Spray-applied polyurea membranes, continuous and resistant, seamless." },
  },
  {
    id: "tanks", icon: "tanks", scene: ASSETS.tankInterior,
    it: { name: "Manutenzione serbatoi", desc: "Bonifica, ispezione e riqualifica di serbatoi e recipienti industriali." },
    en: { name: "Tank maintenance", desc: "Reclamation, inspection and requalification of industrial tanks and vessels." },
  },
  {
    id: "corrosion", icon: "corrosion", scene: ASSETS.inspectionTablet,
    it: { name: "Protezione anticorrosione", desc: "Progetti di protezione a lungo termine con controllo qualita documentato." },
    en: { name: "Corrosion protection", desc: "Long-term protection projects with documented quality control." },
  },
];

export const EQUIPMENT = [
  { img: ASSETS.equip.piattaforma, it: "Piattaforma aerea", en: "Aerial platform" },
  { img: ASSETS.equip.sabbiatrice, it: "Sabbiatrice", en: "Sandblaster" },
  { img: ASSETS.equip.motocompressore, it: "Motocompressore", en: "Air compressor" },
  { img: ASSETS.equip.ecoquip, it: "EcoQuip (Graco)", en: "Vapor blasting (Graco)" },
  { img: ASSETS.equip.pallinatrice, it: "Pallinatrice", en: "Shot blaster" },
  { img: ASSETS.equip.abbattitore, it: "Abbattitore polveri", en: "Dust collector" },
];

export const LOCATIONS = [
  { city: "Sede operativa", it: "Sede operativa · Italia", en: "Operations · Italy" },
  { city: "Cantieri", it: "Cantieri · Europa", en: "Projects · Europe" },
];

export const VALUE_ICONS = ["ShieldCheck", "Award", "Leaf", "HeartPulse", "Users", "Lightbulb", "FileCheck2"];

export const COMPANY = {
  legalName: "Metal Covering S.r.l.",
  descriptor: "Abrasive Blasting & Corrosion Protection",
  vat: "02932950799",
  sdi: "M5UXCR1",
  rea: "R.E.A. Vibo Valentia 0163789",
  tel: "+39 327 230 4545",
  telHref: "+393272304545",
  email: "info@metalcovering.org",
  web: "www.metalcovering.org",
  webHref: "https://www.metalcovering.org",
  youtube: "https://www.youtube.com/channel/UCAWhzNK9Y3xhACKovo80lFA",
  registered: {
    it: "Sede legale",
    en: "Registered office",
    lines: ["Via Campania s.n.c.", "89900 Vibo Valentia Marina (VV) — Italia"],
    short: "Vibo Valentia Marina (VV)",
  },
  lainate: {
    it: "Ufficio Lainate",
    en: "Lainate office",
    lines: ["Piazza Vittorio Emanuele II, 6", "20045 Lainate (MI) — Italia"],
    short: "Lainate (MI)",
  },
  temporary: {
    it: "Presìdi operativi temporanei",
    en: "Temporary operational presences",
    items: [
      { name: "SERAM", place: "Fiumicino (RM)" },
      { name: "SARPOM — Raffineria di Trecate", place: "Trecate (NO)" },
    ],
  },
};
